'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var styled = require('styled-components');
var element = require('./element-2cae4d89.js');
var element$1 = require('./element-eba06ad0.js');
var colorPalette = require('./color-palette-14d554dc.js');
require('react-helmet');
var zIndices = require('./z-indices-4192e40e.js');
var defaultTheme = require('./defaultTheme-068d5ee4.js');
var withStyles = require('./withStyles-b393a9eb.js');
var capitalize = require('./capitalize-4d39daf3.js');
var Paper = require('./Paper-219dcd73.js');
var hooks_useWrappedFunction = require('./hooks/use-wrapped-function/index.js');
var iconLibrary_systemIcons_microIcons_chevronDown = require('./icon-library/system-icons/micro-icons/chevron-down/index.js');
var iconLibrary_systemIcons_microIcons_chevronUp = require('./icon-library/system-icons/micro-icons/chevron-up/index.js');
var iconLibrary_systemIcons_standardIcons_arrowRight = require('./icon-library/system-icons/standard-icons/arrow-right/index.js');
var element$2 = require('./element-2d0b0a9a.js');
var hooks_useSanitizedUrl = require('./hooks/use-sanitized-url/index.js');
require('./social-button-8479390a.js');
var iconButtons = require('./icon-buttons-442762e4.js');
var elementOutline = require('./element-outline-e92b8ea2.js');
var focusVisibleSelector = require('./focus-visible-selector-7139d43f.js');
var component = require('./component-21a580e6.js');
var Link = require('./Link-d540ccdb.js');
var iconLink = require('./icon-link-f19c861a.js');
var debounce = require('./debounce-41e267c7.js');
var hooks_useCombinedClassName = require('./hooks/use-combined-class-name/index.js');
var iconLibrary_systemIcons_standardIcons_closeLarge = require('./icon-library/system-icons/standard-icons/close-large/index.js');
var component$1 = require('./component-a6756b54.js');
var useTheme = require('./useTheme-663f5947.js');
var tooltip = require('./tooltip-e34b5863.js');
var useIsFocusVisible = require('./useIsFocusVisible-5ebbc940.js');
var ReactDOM = require('react-dom');
var Modal = require('./Modal-602b2681.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var ReactDOM__namespace = /*#__PURE__*/_interopNamespace(ReactDOM);

var styles$3 = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0,
      '@media print': {
        // Prevent the app bar to be visible on each printed page.
        position: 'absolute'
      }
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: 'relative'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="transparent"`. */
    colorTransparent: {
      backgroundColor: 'transparent',
      color: 'inherit'
    }
  };
};
var AppBar = /*#__PURE__*/React__namespace.forwardRef(function AppBar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$position = props.position,
      position = _props$position === void 0 ? 'fixed' : _props$position,
      other = defaultTheme._objectWithoutProperties(props, ["classes", "className", "color", "position"]);

  return /*#__PURE__*/React__namespace.createElement(Paper.Paper, defaultTheme._extends({
    square: true,
    component: "header",
    elevation: 4,
    className: withStyles.clsx(classes.root, classes["position".concat(capitalize.capitalize(position))], classes["color".concat(capitalize.capitalize(color))], className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
process.env.NODE_ENV !== "production" ? AppBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: defaultTheme.PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),

  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: defaultTheme.PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
} : void 0;
var AppBar$1 = withStyles.withStyles(styles$3, {
  name: 'MuiAppBar'
})(AppBar);

var _templateObject$4;
var navBarBaseStyle = styled.css(["max-width:100%;background-color:", ";color:", ";box-shadow:", "px ", "px ", "px ", ";display:flex;justify-content:center;z-index:", ";"], colorPalette.WHITE_100, colorPalette.CHARCOAL_100, element.ownUpWhiteTheme.spacing(0.5), element.ownUpWhiteTheme.spacing(0.5), element.ownUpWhiteTheme.spacing(1), colorPalette.CHARCOAL_5, zIndices.Z_INDICES.NAVBAR_BASE);
var NavBarGridWrapper = styled__default['default'](element$1.OwnUpGridWrapper)(_templateObject$4 || (_templateObject$4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n"])));

var _excluded$4 = ["children"];
var _templateObject$3;
var OwnUpNavBarImpl = styled__default['default'](AppBar$1)(_templateObject$3 || (_templateObject$3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  height: 4.5rem;\n  ", " {\n    height: 5rem;\n  }\n"])), navBarBaseStyle, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up('lg');
});

/**
 * A nav bar element. This bar provides its own {@see OwnUpGridWrapper} and
 *   {@see OwnUpGridContainer}. The immediate children should be
 *   {@see OwnUpGridItem}s. If you don't want to use them, you should
 *   wrap the children in `<OwnUpGridItem xs={12} />` to satisfy the
 *   grid structure requirements.
 *
 * @param props - {@see OwnUpNavbarProps}
 */
var OwnUpNavBar = function OwnUpNavBar(_ref2) {
  var children = _ref2.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref2, _excluded$4);
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavBarImpl, props, /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: element.ownUpWhiteTheme
  }, /*#__PURE__*/React__default['default'].createElement(NavBarGridWrapper, null, /*#__PURE__*/React__default['default'].createElement(element$1.OwnUpGridContainer, {
    variant: "slim"
  }, children))));
};

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2;
// Nav bar icon

var navigationIconSpacing = element.ownUpWhiteTheme.spacing(1) + 'px';
var navigationIconSize = '1.25rem';
var NavIconStyle = styled__default['default'](component.OwnUpIcon)(_templateObject$2 || (_templateObject$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: inline-block;\n  padding-right: ", ";\n  height: ", ";\n  vertical-align: middle;\n"])), navigationIconSpacing, navigationIconSize);

// Nav link

var navLinkTextStyle = styled.css(["display:inline-flex;align-items:center;span{vertical-align:middle;}"]);
var navLinkTextStyleSmall = styled.css(["", " ", ""], element$2.ownUpBodyMediumMixin, navLinkTextStyle);
var navLinkTextStyleMedium = styled.css(["", " ", ""], element$2.ownUpLargeBodyMediumMixin, navLinkTextStyle);
var navLinkTextStyleLarge = styled.css(["", " ", ""], element$2.ownUpSmallSubheadlineMediumMixin, navLinkTextStyle);
var navigationFontColorHover = colorPalette.ALOE_100;
var navigationFontColorFocus = colorPalette.ALOE_100;
var navigationFocus = '2px';
var navigationFocusRadius = '4px';
var navigationFocusSpacing = '4px';
var OwnUpNavLinkWrapper = styled__default['default'](Link.Link)(_templateObject2$2 || (_templateObject2$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  cursor: pointer;\n  color: ", ";\n  padding: 0 ", ";\n  height: 100%;\n\n  &:visited {\n    color: ", ";\n  }\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n  &", " {\n    color: ", ";\n    ", "\n  }\n\n  &:focus {\n    outline-style: unset;\n  }\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme,
    $currentlyVisiting = _ref.$currentlyVisiting;
  return $currentlyVisiting ? theme.navLinkColors.navigationFontColorSelected : theme.navLinkColors.navigationFontColorActive;
}, navigationFocusSpacing, function (_ref2) {
  var theme = _ref2.theme,
    $currentlyVisiting = _ref2.$currentlyVisiting;
  return $currentlyVisiting ? theme.navLinkColors.navigationFontColorSelected : theme.navLinkColors.navigationFontColorActive;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.navLinkColors.navigationFontColorHover;
}, focusVisibleSelector.focusVisibleSelectorMixin, function (_ref4) {
  var theme = _ref4.theme;
  return theme.navLinkColors.navigationFontColorFocus;
}, function (_ref5) {
  var theme = _ref5.theme;
  return elementOutline.createElementOutlineMixin({
    color: theme.navLinkColors.navigationFontColorFocus,
    width: navigationFocus,
    inset: 0,
    radius: navigationFocusRadius
  });
}, function (_ref6) {
  var size = _ref6.size;
  switch (size) {
    case 'small':
      return navLinkTextStyleSmall;
    case 'medium':
      return navLinkTextStyleMedium;
    default:
      return navLinkTextStyleLarge;
  }
});

// Nav button

var OwnUpNavButtonContainer = styled__default['default'].div(_templateObject3$2 || (_templateObject3$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  height: ", ";\n"])), function (_ref7) {
  var $onModal = _ref7.$onModal;
  return $onModal ? 'fit-content' : '100%';
});
// A couple notes:
// - Need to apply appropriate css to the button when the parent element is focused/hovered
// - The NavLink has its own focusVisible mixin, but this needs to be overriden here
//    for the icon spacing
var OwnUpNavButtonWrapper = styled__default['default'](OwnUpNavLinkWrapper)(_templateObject4$2 || (_templateObject4$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  button {\n    background: ", ";\n  }\n\n  &:focus > button {\n    background: ", ";\n  }\n\n  &:hover > button {\n    &:not(&[aria-disabled='true']) {\n      background: ", ";\n    }\n  }\n\n  &", " {\n    color: ", ";\n    ", "\n    &::after {\n      left: 0;\n      right: 0;\n    }\n  }\n  position: relative;\n"])), function (_ref8) {
  var size = _ref8.size;
  switch (size) {
    case 'small':
      return navLinkTextStyleSmall;
    case 'medium':
      return navLinkTextStyleMedium;
    default:
      return navLinkTextStyleLarge;
  }
}, function (_ref9) {
  var $showDrawer = _ref9.$showDrawer,
    $currentlyVisiting = _ref9.$currentlyVisiting,
    theme = _ref9.theme;
  if ($showDrawer) {
    return navigationFontColorHover;
  } else if ($currentlyVisiting) {
    return theme.navLinkColors.navigationFontColorSelected;
  } else {
    return '';
  }
}, function (_ref10) {
  var _theme$buttonColors$i;
  var $showDrawer = _ref10.$showDrawer,
    theme = _ref10.theme;
  return $showDrawer ? (_theme$buttonColors$i = theme.buttonColors.iconButtons.defaultColors) === null || _theme$buttonColors$i === void 0 ? void 0 : _theme$buttonColors$i.backgroundColorHover : '';
}, function (_ref11) {
  var _theme$buttonColors$i2;
  var theme = _ref11.theme;
  return (_theme$buttonColors$i2 = theme.buttonColors.iconButtons.defaultColors) === null || _theme$buttonColors$i2 === void 0 ? void 0 : _theme$buttonColors$i2.backgroundColorFocus;
}, function (_ref12) {
  var _theme$buttonColors$i3;
  var theme = _ref12.theme;
  return (_theme$buttonColors$i3 = theme.buttonColors.iconButtons.defaultColors) === null || _theme$buttonColors$i3 === void 0 ? void 0 : _theme$buttonColors$i3.backgroundColorHover;
}, focusVisibleSelector.focusVisibleSelectorMixin, navigationFontColorFocus, function () {
  return elementOutline.createElementOutlineMixin({
    color: navigationFontColorFocus,
    width: navigationFocus,
    radius: navigationFocusRadius
  });
});

// Setting margin-top is because the icon wasn't centering properly.
//  Used negative margin on top because doing it on the bottom changed the height
//  of the parent element and messed up the size.
var NavButtonIconStyle = styled__default['default'](iconButtons.OwnUpIconButton)(_templateObject5$2 || (_templateObject5$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin-left: ", ";\n"])), navigationIconSpacing);
var NavMenuDrawerContainer = styled__default['default'].div(_templateObject6$2 || (_templateObject6$2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: ", ";\n"])), function (_ref13) {
  var showDrawer = _ref13.showDrawer;
  return showDrawer ? 'block' : 'none';
});

var _excluded$3 = ["children", "icon", "href"];
var OwnUpNavLink = function OwnUpNavLink(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    href = _ref.href,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$3);
  var theme = styled.useTheme();
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavLinkWrapper, _rollupPluginBabelHelpers._extends({
    tabIndex: 0,
    href: hooks_useSanitizedUrl.useSanitizedUrl(href)
  }, props), icon && /*#__PURE__*/React__default['default'].createElement(NavIconStyle, {
    icon: icon,
    color: theme.navLinkColors.navigationIconColor
  }), /*#__PURE__*/React__default['default'].createElement("span", null, children));
};

/**
 * Only used with a full width NavBar
 *
 * @deprecated Use OwnUpNavLink with size prop.
 */
var OwnUpNavLinkSmall = function OwnUpNavLinkSmall(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavLink, _rollupPluginBabelHelpers._extends({}, props, {
    size: "small"
  }));
};

/**
 * Only used with NavBarModal
 *
 * @deprecated Use OwnUpNavLink with size prop.
 */
var OwnUpNavLinkMedium = function OwnUpNavLinkMedium(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavLink, _rollupPluginBabelHelpers._extends({}, props, {
    size: "medium"
  }));
};

/**
 * Only used with NavBarModal
 *
 * @deprecated Use OwnUpNavLink with size prop.
 */
var OwnUpNavLinkLarge = function OwnUpNavLinkLarge(props) {
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavLink, _rollupPluginBabelHelpers._extends({}, props, {
    size: "large"
  }));
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1;
var FullWidthContainer = styled__default['default'].div(_templateObject$1 || (_templateObject$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  width: 100vw;\n  background: ", ";\n  box-shadow: 4px 4px 8px 0px ", ";\n  z-index: ", ";\n  position: fixed;\n  left: 0;\n"])), colorPalette.FOG_20, colorPalette.CHARCOAL_5, zIndices.Z_INDICES.NAVBAR_DRAWER);
var OwnUpNavMenuDrawerStyleDesktop = styled__default['default'](element$1.OwnUpGridWrapper)(_templateObject2$1 || (_templateObject2$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n"])), element.ownUpWhiteTheme.spacing(6), element.ownUpWhiteTheme.spacing(8));
var DescriptionStyle = styled__default['default'](element$2.OwnUpSmallBody)(_templateObject3$1 || (_templateObject3$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), element.ownUpWhiteTheme.spacing(2));
var MenuDrawerItemDesktop = styled__default['default'].div(_templateObject4$1 || (_templateObject4$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  flex: 1 1 0;\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacing(0, 1.5);
});
var DrawerItemLinkDesktop = styled__default['default'](iconLink.IconLink)(_templateObject5$1 || (_templateObject5$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), element.ownUpWhiteTheme.spacing(2));
var ModalDrawerContainer = styled__default['default'].div(_templateObject6$1 || (_templateObject6$1 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin-left: ", "px;\n  display: flex;\n  flex-direction: column;\n"])), element.ownUpWhiteTheme.spacing(3));

var _excluded$2 = ["onModal", "children"];
var OwnUpNavMenuDrawer = function OwnUpNavMenuDrawer(_ref) {
  var _ref$onModal = _ref.onModal,
    onModal = _ref$onModal === void 0 ? false : _ref$onModal,
    children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$2);
  return onModal ? /*#__PURE__*/React__default['default'].createElement(ModalDrawerContainer, null, children) : /*#__PURE__*/React__default['default'].createElement(FullWidthContainer, props, /*#__PURE__*/React__default['default'].createElement(OwnUpNavMenuDrawerStyleDesktop, null, /*#__PURE__*/React__default['default'].createElement(element$1.OwnUpGridContainer, {
    variant: "slim"
  }, children)));
};
var OwnUpNavMenuDrawerItemDesktop = function OwnUpNavMenuDrawerItemDesktop(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    link = _ref2.link,
    _ref2$linkText = _ref2.linkText,
    linkText = _ref2$linkText === void 0 ? 'Link' : _ref2$linkText,
    linkProps = _ref2.linkProps;
  return /*#__PURE__*/React__default['default'].createElement(MenuDrawerItemDesktop, null, /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: element.ownUpWhiteTheme
  }, /*#__PURE__*/React__default['default'].createElement(element$2.OwnUpLargeBodyMedium, {
    variant: "body1"
  }, title), /*#__PURE__*/React__default['default'].createElement(DescriptionStyle, {
    variant: "body2"
  }, description), /*#__PURE__*/React__default['default'].createElement(DrawerItemLinkDesktop, _rollupPluginBabelHelpers._extends({
    icon: /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_standardIcons_arrowRight.ArrowRightIcon, null),
    link: link
  }, linkProps), linkText)));
};
var OwnUpNavMenuItemModal = function OwnUpNavMenuItemModal(_ref3) {
  var title = _ref3.title,
    link = _ref3.link,
    linkProps = _ref3.linkProps;
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavLink, _rollupPluginBabelHelpers._extends({
    size: "small",
    href: link,
    className: "modal-drawer-link"
  }, linkProps), title);
};

var _excluded$1 = ["drawerItems", "defaultShowDrawer", "onModal", "children", "onFocus", "onClick", "onBlur", "onMouseEnter", "onMouseLeave", "className"];
var OwnUpNavButton = function OwnUpNavButton(_ref) {
  var drawerItems = _ref.drawerItems,
    _ref$defaultShowDrawe = _ref.defaultShowDrawer,
    defaultShowDrawer = _ref$defaultShowDrawe === void 0 ? false : _ref$defaultShowDrawe,
    _ref$onModal = _ref.onModal,
    onModal = _ref$onModal === void 0 ? false : _ref$onModal,
    children = _ref.children,
    onFocus = _ref.onFocus,
    onClick = _ref.onClick,
    onBlur = _ref.onBlur,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    className = _ref.className,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded$1);
  var _useState = React.useState(defaultShowDrawer),
    _useState2 = _rollupPluginBabelHelpers._slicedToArray(_useState, 2),
    showDrawer = _useState2[0],
    setShowDrawer = _useState2[1];
  // There is a race condition where clicking on the element also focuses the element,
  // and toggle gets called twice.  Need to debounce the onFocus and onClick events.
  var debounceToggle = debounce.debounce(setShowDrawer, 150);
  var handleFocus = hooks_useWrappedFunction.useWrappedFunction(function () {
    debounceToggle(true);
  }, onFocus);
  var handleClick = hooks_useWrappedFunction.useWrappedFunction(function () {
    return debounceToggle(!showDrawer);
  }, onClick);
  var handleBlur = hooks_useWrappedFunction.useWrappedFunction(function (_ref2) {
    var relatedTarget = _ref2.relatedTarget,
      currentTarget = _ref2.currentTarget;
    if (relatedTarget !== null && currentTarget !== null) {
      if (currentTarget.contains(relatedTarget)) {
        return;
      }
    }
    setShowDrawer(false);
  }, onBlur);
  var handleMouseOver = hooks_useWrappedFunction.useWrappedFunction(function () {
    return setShowDrawer(true);
  }, onMouseEnter);
  var handleMouseLeave = hooks_useWrappedFunction.useWrappedFunction(function () {
    return setShowDrawer(false);
  }, onMouseLeave);
  var drawerItemsElement = onModal ? drawerItems.map(function (_ref3) {
    var title = _ref3.title,
      link = _ref3.link,
      linkProps = _ref3.linkProps;
    return /*#__PURE__*/React__default['default'].createElement(OwnUpNavMenuItemModal, {
      title: title,
      link: link,
      linkProps: linkProps,
      key: title
    });
  }) : drawerItems.map(function (_ref4) {
    var title = _ref4.title,
      description = _ref4.description,
      linkProps = _ref4.linkProps,
      link = _ref4.link,
      linkText = _ref4.linkText;
    return /*#__PURE__*/React__default['default'].createElement(OwnUpNavMenuDrawerItemDesktop, {
      title: title,
      description: description,
      link: link,
      linkProps: linkProps,
      key: title,
      linkText: linkText
    });
  });
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavButtonContainer, {
    onMouseOver: !onModal ? handleMouseOver : undefined,
    onMouseLeave: !onModal ? handleMouseLeave : undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    $onModal: onModal,
    className: className
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpNavButtonWrapper, _rollupPluginBabelHelpers._extends({
    tabIndex: 0,
    onClick: handleClick,
    $showDrawer: showDrawer
  }, props), children, /*#__PURE__*/React__default['default'].createElement(NavButtonIconStyle, {
    icon: showDrawer ? iconLibrary_systemIcons_microIcons_chevronUp.MicroChevronUpIcon : iconLibrary_systemIcons_microIcons_chevronDown.MicroChevronDownIcon,
    size: props.size === 'large' ? 1.5 : 1.25,
    name: props.name,
    tabIndex: -1 // Only the parent element should be focused, not the icon alone
  })), /*#__PURE__*/React__default['default'].createElement(NavMenuDrawerContainer, {
    showDrawer: showDrawer
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpNavMenuDrawer, {
    onModal: onModal
  }, drawerItemsElement)));
};

/**
 * Only used with a full width NavBar
 */
var OwnUpNavButtonSmall = function OwnUpNavButtonSmall(_ref5) {
  var props = _rollupPluginBabelHelpers._extends({}, (_rollupPluginBabelHelpers._objectDestructuringEmpty(_ref5), _ref5));
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavButton, _rollupPluginBabelHelpers._extends({
    size: "small"
  }, props));
};

/**
 * Only used with NavBarModal
 */
var OwnUpNavButtonMedium = function OwnUpNavButtonMedium(_ref6) {
  var props = _rollupPluginBabelHelpers._extends({}, (_rollupPluginBabelHelpers._objectDestructuringEmpty(_ref6), _ref6));
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavButton, _rollupPluginBabelHelpers._extends({
    size: "medium"
  }, props));
};

/**
 * Only used with NavBarModal
 */
var OwnUpNavButtonLarge = function OwnUpNavButtonLarge(_ref7) {
  var props = _rollupPluginBabelHelpers._extends({}, (_rollupPluginBabelHelpers._objectDestructuringEmpty(_ref7), _ref7));
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavButton, _rollupPluginBabelHelpers._extends({
    size: "large"
  }, props));
};

var styles$2 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout$1 = {
  enter: defaultTheme.duration.enteringScreen,
  exit: defaultTheme.duration.leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/React__namespace.forwardRef(function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? tooltip.Transition : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout$1 : _props$timeout,
      other = defaultTheme._objectWithoutProperties(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = useTheme.useTheme();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React__namespace.useRef(null);
  var foreignRef = useIsFocusVisible.useForkRef(children.ref, ref);
  var handleRef = useIsFocusVisible.useForkRef(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = defaultTheme._slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    tooltip.reflow(node); // So the animation always start from the start.

    var transitionProps = tooltip.getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = tooltip.getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/React__namespace.createElement(TransitionComponent, defaultTheme._extends({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React__namespace.cloneElement(children, defaultTheme._extends({
      style: defaultTheme._extends({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles$2[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
process.env.NODE_ENV !== "production" ? Fade.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: defaultTheme.PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onEntered: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onEntering: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExit: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExited: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExiting: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  style: defaultTheme.PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.shape({
    appear: defaultTheme.PropTypes.number,
    enter: defaultTheme.PropTypes.number,
    exit: defaultTheme.PropTypes.number
  })])
} : void 0;

var styles$1 = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/React__namespace.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade : _props$TransitionComp,
      other = defaultTheme._objectWithoutProperties(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/React__namespace.createElement(TransitionComponent, defaultTheme._extends({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/React__namespace.createElement("div", {
    className: withStyles.clsx(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
process.env.NODE_ENV !== "production" ? Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: defaultTheme.PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: defaultTheme.PropTypes.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.shape({
    appear: defaultTheme.PropTypes.number,
    enter: defaultTheme.PropTypes.number,
    exit: defaultTheme.PropTypes.number
  })])
} : void 0;
var Backdrop$1 = withStyles.withStyles(styles$1, {
  name: 'MuiBackdrop'
})(Backdrop);

// Later, we gonna translate back the node to his original location
// with `none`.`

function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}

function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var defaultTimeout = {
  enter: defaultTheme.duration.enteringScreen,
  exit: defaultTheme.duration.leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide = /*#__PURE__*/React__namespace.forwardRef(function Slide(props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? tooltip.Transition : _props$TransitionComp,
      other = defaultTheme._objectWithoutProperties(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = useTheme.useTheme();
  var childrenRef = React__namespace.useRef(null);
  /**
   * used in cloneElement(children, { ref: handleRef })
   */

  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    childrenRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  var handleRefIntermediary = useIsFocusVisible.useForkRef(children.ref, handleOwnRef);
  var handleRef = useIsFocusVisible.useForkRef(handleRefIntermediary, ref);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (isAppearing) {
      if (callback) {
        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (isAppearing === undefined) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    setTranslateValue(direction, node);
    tooltip.reflow(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var transitionProps = tooltip.getTransitionProps({
      timeout: timeout,
      style: style
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', defaultTheme._extends({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create('transform', defaultTheme._extends({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = tooltip.getTransitionProps({
      timeout: timeout,
      style: style
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', defaultTheme._extends({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create('transform', defaultTheme._extends({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function (node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });
  var updatePosition = React__namespace.useCallback(function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  React__namespace.useEffect(function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = debounce.debounce(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  React__namespace.useEffect(function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/React__namespace.createElement(TransitionComponent, defaultTheme._extends({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    appear: true,
    in: inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React__namespace.cloneElement(children, defaultTheme._extends({
      ref: handleRef,
      style: defaultTheme._extends({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, children.props.style)
    }, childProps));
  });
});
process.env.NODE_ENV !== "production" ? Slide.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: tooltip.elementAcceptingRef,

  /**
   * Direction the child node will enter from.
   */
  direction: defaultTheme.PropTypes.oneOf(['down', 'left', 'right', 'up']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: defaultTheme.PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onEntered: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onEntering: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExit: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExited: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  onExiting: defaultTheme.PropTypes.func,

  /**
   * @ignore
   */
  style: defaultTheme.PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.shape({
    appear: defaultTheme.PropTypes.number,
    enter: defaultTheme.PropTypes.number,
    exit: defaultTheme.PropTypes.number
  })])
} : void 0;

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
var defaultTransitionDuration = {
  enter: defaultTheme.duration.enteringScreen,
  exit: defaultTheme.duration.leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

var Drawer = /*#__PURE__*/React__namespace.forwardRef(function Drawer(props, ref) {
  var _props$anchor = props.anchor,
      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
      BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropPropsProp = _props$ModalProps.BackdropProps,
      ModalProps = defaultTheme._objectWithoutProperties(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SlideProps = props.SlideProps,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Slide : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = defaultTheme._objectWithoutProperties(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);

  var theme = useTheme.useTheme(); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.

  var mounted = React__namespace.useRef(false);
  React__namespace.useEffect(function () {
    mounted.current = true;
  }, []);
  var anchor = getAnchor(theme, anchorProp);
  var drawer = /*#__PURE__*/React__namespace.createElement(Paper.Paper, defaultTheme._extends({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: withStyles.clsx(classes.paper, classes["paperAnchor".concat(capitalize.capitalize(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat(capitalize.capitalize(anchor))])
  }), children);

  if (variant === 'permanent') {
    return /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
      className: withStyles.clsx(classes.root, classes.docked, className),
      ref: ref
    }, other), drawer);
  }

  var slidingDrawer = /*#__PURE__*/React__namespace.createElement(TransitionComponent, defaultTheme._extends({
    in: open,
    direction: oppositeDirection[anchor],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps), drawer);

  if (variant === 'persistent') {
    return /*#__PURE__*/React__namespace.createElement("div", defaultTheme._extends({
      className: withStyles.clsx(classes.root, classes.docked, className),
      ref: ref
    }, other), slidingDrawer);
  } // variant === temporary


  return /*#__PURE__*/React__namespace.createElement(Modal.Modal, defaultTheme._extends({
    BackdropProps: defaultTheme._extends({}, BackdropProps, BackdropPropsProp, {
      transitionDuration: transitionDuration
    }),
    BackdropComponent: Backdrop$1,
    className: withStyles.clsx(classes.root, classes.modal, className),
    open: open,
    onClose: onClose,
    ref: ref
  }, other, ModalProps), slidingDrawer);
});
process.env.NODE_ENV !== "production" ? Drawer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Side from which the drawer will appear.
   */
  anchor: defaultTheme.PropTypes.oneOf(['bottom', 'left', 'right', 'top']),

  /**
   * @ignore
   */
  BackdropProps: defaultTheme.PropTypes.object,

  /**
   * The contents of the drawer.
   */
  children: defaultTheme.PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: defaultTheme.PropTypes.object,

  /**
   * @ignore
   */
  className: defaultTheme.PropTypes.string,

  /**
   * The elevation of the drawer.
   */
  elevation: defaultTheme.PropTypes.number,

  /**
   * Props applied to the [`Modal`](/api/modal/) element.
   */
  ModalProps: defaultTheme.PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: defaultTheme.PropTypes.func,

  /**
   * If `true`, the drawer is open.
   */
  open: defaultTheme.PropTypes.bool,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: defaultTheme.PropTypes.object,

  /**
   * Props applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: defaultTheme.PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: defaultTheme.PropTypes.oneOfType([defaultTheme.PropTypes.number, defaultTheme.PropTypes.shape({
    appear: defaultTheme.PropTypes.number,
    enter: defaultTheme.PropTypes.number,
    exit: defaultTheme.PropTypes.number
  })]),

  /**
   * The variant to use.
   */
  variant: defaultTheme.PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
var Drawer$1 = withStyles.withStyles(styles, {
  name: 'MuiDrawer',
  flip: false
})(Drawer);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
var ModalSection = styled__default['default'].div(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  padding: 0 ", "px;\n  ", " {\n    padding: 0 ", "px;\n  }\n  ", " {\n    padding: 0 ", "px;\n    width: 100%;\n  }\n  ", "\n"])), element.ownUpWhiteTheme.spacing(10), function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down('md');
}, element.ownUpWhiteTheme.spacing(6), function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down('xs');
}, element.ownUpWhiteTheme.spacing(3), function (_ref3) {
  var $footer = _ref3.$footer;
  if ($footer) {
    return styled.css(["margin-top:", "px;background:", ";height:100%;"], element.ownUpWhiteTheme.spacing(4), colorPalette.FOG_20);
  }
});
var OwnUpNavModalHeader = styled__default['default'].div(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  height: 4.5rem;\n  ", " {\n    height: 5rem;\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up('lg');
});
var ModalOwnUpLogoDesktopContainer = styled__default['default'](component$1.OwnUpLogoLink)(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: block;\n  ", " {\n    display: none;\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.down('xs');
});
var ModalOwnUpLogoMobileContainer = styled__default['default'](component$1.OwnUpLogoWithTextLink)(_templateObject4 || (_templateObject4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: block;\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.down('xs');
});
var ModalLinksContainer = styled__default['default'].div(_templateObject5 || (_templateObject5 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  padding-top: ", "px;\n  display: flex;\n  flex-direction: column;\n  gap: ", "px;\n"])), element.ownUpWhiteTheme.spacing(4), element.ownUpWhiteTheme.spacing(4));
var ModalButtonsContainer = styled__default['default'].div(_templateObject6 || (_templateObject6 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding-top: ", "px;\n  width: fit-content;\n  ", " {\n    width: 100%;\n  }\n  padding-bottom: 40px;\n  > :last-child {\n    margin-top: 12px;\n  }\n"])), element.ownUpWhiteTheme.spacing(4), function (_ref7) {
  var theme = _ref7.theme;
  return theme.breakpoints.down('xs');
});
var OwnUpNavModalContainer = styled__default['default'](Drawer$1)(_templateObject7 || (_templateObject7 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  .MuiBackdrop-root {\n    background-color: ", ";\n  }\n\n  .MuiDrawer-paper {\n    display: flex;\n    width: 50%;\n    min-width: 320px;\n    box-shadow: -4px 4px 8px 0px ", ";\n    ", " {\n      width: 100%;\n    }\n  }\n\n  .MuiLink-underlineHover {\n    height: fit-content;\n    padding: 0;\n  }\n\n  .modal-drawer-link {\n    margin-top: ", "px;\n  }\n"])), colorPalette.CHARCOAL_40, colorPalette.CHARCOAL_5, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoints.down('xs');
}, element.ownUpWhiteTheme.spacing(3));

var _excluded = ["children", "className", "buttons", "homepageLinkProps", "onClose"];
var OwnUpNavMenuModal = function OwnUpNavMenuModal(_ref) {
  var children = _ref.children,
    className = _ref.className,
    buttons = _ref.buttons,
    homepageLinkProps = _ref.homepageLinkProps,
    onClose = _ref.onClose,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  var exitButtonName = hooks_useCombinedClassName.useCombinedClassName(className, 'nav-modal-exit-button');
  return /*#__PURE__*/React__default['default'].createElement(OwnUpNavModalContainer, _rollupPluginBabelHelpers._extends({
    anchor: "right",
    elevation: 0,
    onClose: onClose
  }, props), /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: element.ownUpWhiteTheme
  }, /*#__PURE__*/React__default['default'].createElement(ModalSection, null, /*#__PURE__*/React__default['default'].createElement(OwnUpNavModalHeader, null, /*#__PURE__*/React__default['default'].createElement(ModalOwnUpLogoDesktopContainer, homepageLinkProps), /*#__PURE__*/React__default['default'].createElement(ModalOwnUpLogoMobileContainer, homepageLinkProps), /*#__PURE__*/React__default['default'].createElement(iconButtons.OwnUpIconButtonQuiet, {
    className: exitButtonName,
    "data-test-id": "modalExitButton",
    name: "Modal Exit Button",
    size: 2.5,
    onClick: function onClick() {
      return onClose();
    },
    icon: /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_standardIcons_closeLarge.CloseLargeIcon, null)
  })), /*#__PURE__*/React__default['default'].createElement(ModalLinksContainer, null, children)), buttons ? /*#__PURE__*/React__default['default'].createElement(ModalSection, {
    $footer: true
  }, /*#__PURE__*/React__default['default'].createElement(ModalButtonsContainer, null, buttons)) : null));
};

exports.OwnUpNavBar = OwnUpNavBar;
exports.OwnUpNavBarImpl = OwnUpNavBarImpl;
exports.OwnUpNavButtonLarge = OwnUpNavButtonLarge;
exports.OwnUpNavButtonMedium = OwnUpNavButtonMedium;
exports.OwnUpNavButtonSmall = OwnUpNavButtonSmall;
exports.OwnUpNavLink = OwnUpNavLink;
exports.OwnUpNavLinkLarge = OwnUpNavLinkLarge;
exports.OwnUpNavLinkMedium = OwnUpNavLinkMedium;
exports.OwnUpNavLinkSmall = OwnUpNavLinkSmall;
exports.OwnUpNavMenuDrawer = OwnUpNavMenuDrawer;
exports.OwnUpNavMenuDrawerItemDesktop = OwnUpNavMenuDrawerItemDesktop;
exports.OwnUpNavMenuItemModal = OwnUpNavMenuItemModal;
exports.OwnUpNavMenuModal = OwnUpNavMenuModal;
//# sourceMappingURL=nav-menu-modal-94dd43c8.js.map
